export enum OnsiteMessageDisplayType {
  Overlay = 'Overlay',
}
